import { APP_LANGUAGE_SYSTEM } from "./settings/appSettings.js";
import { PROFILE_CURRENCY_ILS } from "./settings/profileSettings.js";

let formattingPreferences = {
  language: APP_LANGUAGE_SYSTEM,
  currency: PROFILE_CURRENCY_ILS
};

function resolveLocale(language) {
  return language === APP_LANGUAGE_SYSTEM ? undefined : language;
}

function createCurrencyFormatter() {
  return new Intl.NumberFormat(resolveLocale(formattingPreferences.language), {
    style: "currency",
    currency: formattingPreferences.currency,
    minimumFractionDigits: 0,
    maximumFractionDigits: 0
  });
}

let currencyFormatter = createCurrencyFormatter();
const LTR_ISOLATE_START = "\u2066";
const DIRECTIONAL_ISOLATE_END = "\u2069";
const numberPartTypes = new Set(["integer", "group", "decimal", "fraction", "nan", "infinity"]);

export function setFormattingPreferences(nextPreferences = {}) {
  formattingPreferences = {
    ...formattingPreferences,
    ...nextPreferences
  };
  currencyFormatter = createCurrencyFormatter();
}

export function formatCurrency(value) {
  const parts = currencyFormatter.formatToParts(Number(value || 0));
  const sign = parts
    .filter((part) => part.type === "minusSign" || part.type === "plusSign")
    .map((part) => part.value)
    .join("");
  const currency = parts
    .filter((part) => part.type === "currency")
    .map((part) => part.value)
    .join("");
  const number = parts
    .filter((part) => numberPartTypes.has(part.type))
    .map((part) => part.value)
    .join("");

  return `${LTR_ISOLATE_START}${sign}${currency}${number}${DIRECTIONAL_ISOLATE_END}`;
}
